const getDefaultUser = () => {
    let user = localStorage.getItem("user");
    if (user && user !== "undefined") {
        return JSON.parse(user);
    } else {
        return {};
    }
};
const authHeader = () => {
    const user = localStorage.getItem("user") ? getDefaultUser() : {};
    const token = user?.token || localStorage.getItem("token");
    if (token) {
        return { Authorization: `${token}` };
    } else {
        return {};
    }
};
export default authHeader;